import React from "react";
import "./Home.css";

const Home = () => {
  return <div>
    <iframe src="https://giphy.com/embed/Q7Y75zDdu3XOn5qCbH" width="100%" height="480" frameBorder="0" class="giphy-embed" allowFullScreen></iframe><p><a href="https://giphy.com/gifs/bleulife-adidas-sneakers-adidasoriginals-Q7Y75zDdu3XOn5qCbH"></a></p>
  </div>;
};

export default Home;
